import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=17b8f8cb&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"
import style0 from "./curd.vue?vue&type=style&index=0&id=17b8f8cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8f8cb",
  null
  
)

export default component.exports